import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SemesterClass from "./SemesterClass";
import styled from "styled-components";

const ClassesTable = styled.table`
  background: transparent;
  border: 0;
  border-spacing: 0;
  margin: 0;
  overflow-y: hidden;
  width: 100%;

  thead {
    display: none;
  }
`;

const SemesterClasses = ({ isAdvisingView, canViewGrades, semester }) => {
  const isInactiveTerm = semester.timeBucket === "past";

  return (
    <div data-testid="semester-classes">
      {!semester.hasEnrolledClasses &&
        !semester.hasWithdrawalData &&
        !semester.hasStudyProgData && (
          <div
            style={{ lineHeight: `1.6`, padding: `15px` }}
            data-testid="semester-classes-no-enrolled"
          >
            You are currently not enrolled in any classes for {semester.name}.
          </div>
        )}
      {semester.hasEnrolledClasses &&
        !semester.hasWithdrawalData &&
        !semester.hasStudyProgData && (
          <div data-testid="enrolled-classes">
            {semester.hasEnrolledClasses && !semester.hasWithdrawalData && (
              <ClassesTable data-testid="semester-classes-table">
                <thead>
                  <tr>
                    <th scope="col">Class</th>
                    <th scope="col">Title</th>
                    {!canViewGrades && (
                      <th scope="col" style={{ textAlign: "center" }}>
                        Units
                      </th>
                    )}
                    {canViewGrades && (
                      <>
                        <th
                          scope="col"
                          title="Units"
                          style={{ textAlign: "center" }}
                        >
                          Units
                        </th>
                        <th
                          scope="col"
                          title="Grade"
                          style={{ textAlign: "center" }}
                        >
                          Grade
                        </th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {semester.classes.map((semesterClass) => (
                    <SemesterClass
                      key={semesterClass.cs_course_id}
                      isInactiveTerm={isInactiveTerm}
                      isAdvisingView={isAdvisingView}
                      semesterClass={semesterClass}
                      canViewGrades={canViewGrades}
                    />
                  ))}
                </tbody>
              </ClassesTable>
            )}
          </div>
        )}
    </div>
  );
};

SemesterClasses.displayName = "SemesterClasses";
SemesterClasses.propTypes = {
  isAdvisingView: PropTypes.bool,
  canViewGrades: PropTypes.bool,
  semester: PropTypes.object,
};

function mapState({ myStatus }) {
  const { canViewGrades = false } = myStatus;

  return { canViewGrades };
}

export default connect(mapState)(SemesterClasses);
